import { Divider, FlexBox, TextSmall } from '@trmediaab/zebra';

interface AltContentDividerProps extends React.ComponentProps<typeof FlexBox> {
  text: string;
  subtle?: boolean;
  leftAligned?: boolean;
}

const AltContentDivider = ({
  text,
  subtle = true,
  leftAligned = false,
  ...props
}: AltContentDividerProps) => (
  <FlexBox alignItems="center" {...props}>
    {!leftAligned && (
      <Divider
        flexGrow="1"
        mt="1px"
        bg={!subtle ? 'text.primary' : undefined}
      />
    )}
    <TextSmall
      fontWeight={!subtle ? 'semiBold' : undefined}
      color={subtle ? 'text.faded' : 'text.primary'}
      pl={leftAligned ? undefined : { _: 2, lg: '2,5' }}
      pr={{ _: 2, lg: '2,5' }}
    >
      {text}
    </TextSmall>
    <Divider flexGrow="1" mt="1px" bg={!subtle ? 'text.primary' : undefined} />
  </FlexBox>
);

export default AltContentDivider;
